<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <div class="tile-grid">

        <!-- Verbal Chess -->
        <div class="tile tile-verbal" @click="navigateTo('verbalchess')">
          <ion-icon :icon="micOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">Verbal Chess</span>
          <span class="tile-sub">{{ t("Play chess using only your voice") }}</span>
        </div>

        <!-- ChessVis AI -->
        <div class="tile tile-ai" @click="navigateTo('chessvisai')">
          <ion-icon :icon="sparklesOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">ChessVis AI</span>
          <span class="tile-sub">{{ t("Your AI chess coach") }}</span>
        </div>

        <!-- The Chess Coach -->
        <!-- <div class="tile tile-coach" @click="navigateTo('chesscoach')">
          <ion-icon :icon="schoolOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">The Chess Coach</span>
          <span class="tile-sub">Live coaching room</span>
        </div> -->

      </div>
    </ion-content>

    <BottomNav @bottom-click="onClick"/>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage, IonHeader, IonToolbar, IonTitle,
  IonButtons, IonBackButton, IonContent, IonIcon,
} from '@ionic/vue'
import {
  micOutline, sparklesOutline, schoolOutline,
} from 'ionicons/icons'
import BottomNav from '@/components/BottomNav.vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { t } from '@/composables/translateText.js'

const emit = defineEmits(['menu-item-click'])

const connectionStore = useConnectionStore()

function navigateTo(app: string) {
  switch (app) {
    case 'verbalchess':
      // Open Verbal Chess — web app or internal route
      //window.open('https://www.verbalchess.fun', '_blank')
      onClick("verbal_play","Verbal Chess","FROM_NEW_MENU")
      break
    case 'chessvisai':
      // Open ChessVis AI
     // window.open('https://www.chessvisai.com', '_blank')
      onClick("chessvis_ai","Chessvis AI","FROM_NEW_MENU")
      break
    case 'chesscoach':
      // Open The Chess Coach landing page
      //router.push('/coaching/landing')
      break
  }
}

  function onClick(path : string,label : string,whichMenu : string) {
    //console.log("Landing page CLICK ",path,label)
    if (path != "") {
      connectionStore.setIsUsingNewMenus(true)
      emit("menu-item-click",path,label,whichMenu)
    }
  }

</script>

<style scoped>
ion-toolbar {
  --background: #12122a;
  --color: #ffffff;
  --border-color: #2a2a4a;
}

ion-back-button { --color: #F5C4B3; }

ion-title {
  font-size: 17px;
  font-weight: 500;
}

ion-content { --background: #1a1a2e; }

/* ── Tile grid — single column, three equal rows ── */
.tile-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 16px;
  height: 100%;
  box-sizing: border-box;
}

.tile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 18px;
  padding: 20px 24px;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
}

.tile:active {
  opacity: 0.85;
  transform: scale(0.97);
}

.tile-icon { font-size: 32px; flex-shrink: 0; }

.tile-label {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.tile-sub {
  font-size: 12px;
  opacity: 0.8;
  line-height: 1.3;
}

/* Stack label and sub vertically */
.tile > div,
.tile-label,
.tile-sub {
  display: block;
}

.tile {
  flex-wrap: wrap;
}

.tile-icon {
  flex: 0 0 auto;
}

.tile-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

/* ── Verbal Chess — coral ── */
.tile-verbal { background: #712B13; }
.tile-verbal .tile-icon { color: #F5C4B3; }
.tile-verbal .tile-label { color: #F5C4B3; }
.tile-verbal .tile-sub { color: #F0997B; }

/* ── ChessVis AI — deep purple ── */
.tile-ai { background: #2d2060; }
.tile-ai .tile-icon { color: #c4bfff; }
.tile-ai .tile-label { color: #c4bfff; }
.tile-ai .tile-sub { color: #9990ee; }

/* ── The Chess Coach — forest green ── */
.tile-coach { background: #1a3a1a; }
.tile-coach .tile-icon { color: #90d490; }
.tile-coach .tile-label { color: #90d490; }
.tile-coach .tile-sub { color: #5daa5d; }
</style>
